@if (formGroup) {
  <app-input-control
    [fg]="formGroup"
    [formGroupOrControlName]="formGroupOrControlName"
    [label]="label"
  ></app-input-control>
}
